// useMpSubscriptions stub - Payment integrations discontinued

export function useMpSubscriptions(_companyId?: string) {
  return {
    data: [],
    isLoading: false,
    refetch: async () => ({ data: [] })
  };
}

export default useMpSubscriptions;
